import { InstanceScreen } from 'component/navigation/instance';

export default function ArticleManagePositionScreen() {
    return <InstanceScreen screenKey='managePosition' />;
}
